import React from 'react'

import { ModulPageMobile } from './ModulIndexPage.mobile'
import { DefaultEmptyModulDetail } from './DefaultEmptyModulDetail.desktop'

export const ModulPage = ({ isDesktop }) => {
  if (isDesktop) {
    return <DefaultEmptyModulDetail />
  }

  return <ModulPageMobile />
}
